import InsertOfferWrapper from "components/InsertOfferWrapper";
import ContactForm from "scenes/InsertOffer/form/Contact";
import { CustomAppPage } from "src/types/types";

const Contact: CustomAppPage = () => (
  <InsertOfferWrapper title="Kontakt u inzerátu">
    <ContactForm buttonNextText="Další" />
  </InsertOfferWrapper>
);

export default Contact;
